<div class="vc-sales-stats">
  <!-- Loading State -->
  <div class="vc-sales-stats__loading" *ngIf="loading">
    <div class="vc-sales-stats__kpis">
      <p-skeleton height="100px" *ngFor="let i of [1, 2, 3, 4]"></p-skeleton>
    </div>
  </div>

  <!-- Stats Content -->
  <div class="vc-sales-stats__content" *ngIf="!loading && stats">
    <!-- KPI Cards -->
    <div class="vc-sales-stats__kpis">
      <div class="vc-sales-stats__kpi">
        <div class="vc-sales-stats__kpi-icon vc-sales-stats__kpi-icon--sales">
          <i class="fas fa-receipt"></i>
        </div>
        <div class="vc-sales-stats__kpi-content">
          <span class="vc-sales-stats__kpi-value">{{ stats.totalSales }}</span>
          <span class="vc-sales-stats__kpi-label">{{
            "SALES.STATS.TOTAL_SALES" | translate
          }}</span>
        </div>
      </div>

      <div class="vc-sales-stats__kpi">
        <div class="vc-sales-stats__kpi-icon vc-sales-stats__kpi-icon--revenue">
          <i class="fas fa-euro-sign"></i>
        </div>
        <div class="vc-sales-stats__kpi-content">
          <span class="vc-sales-stats__kpi-value">{{
            formatCurrency(stats.totalRevenue)
          }}</span>
          <span class="vc-sales-stats__kpi-label">{{
            "SALES.STATS.REVENUE" | translate
          }}</span>
        </div>
      </div>

      <div class="vc-sales-stats__kpi">
        <div class="vc-sales-stats__kpi-icon vc-sales-stats__kpi-icon--average">
          <i class="fas fa-calculator"></i>
        </div>
        <div class="vc-sales-stats__kpi-content">
          <span class="vc-sales-stats__kpi-value">{{
            formatCurrency(stats.averageTicket)
          }}</span>
          <span class="vc-sales-stats__kpi-label">{{
            "SALES.STATS.AVERAGE_TICKET" | translate
          }}</span>
        </div>
      </div>

      <div class="vc-sales-stats__kpi">
        <div
          class="vc-sales-stats__kpi-icon vc-sales-stats__kpi-icon--products"
        >
          <i class="fas fa-box"></i>
        </div>
        <div class="vc-sales-stats__kpi-content">
          <span class="vc-sales-stats__kpi-value">{{
            stats.salesByProduct.length
          }}</span>
          <span class="vc-sales-stats__kpi-label">{{
            "SALES.STATS.PRODUCTS_SOLD" | translate
          }}</span>
        </div>
      </div>
    </div>

    <!-- Charts Row -->
    <div class="vc-sales-stats__charts">
      <!-- Revenue Chart -->
      <div
        class="vc-sales-stats__chart-card"
        *ngIf="stats.dailySales.length > 1"
      >
        <h3 class="vc-sales-stats__chart-title">
          <i class="fas fa-chart-line"></i>
          {{ "SALES.STATS.REVENUE_TREND" | translate }}
        </h3>
        <div class="vc-sales-stats__chart">
          <p-chart
            type="line"
            [data]="revenueChartData"
            [options]="chartOptions"
            height="250px"
          ></p-chart>
        </div>
      </div>

      <!-- Payment Methods Chart -->
      <div
        class="vc-sales-stats__chart-card"
        *ngIf="objectKeys(stats.salesByPaymentMethod).length > 0"
      >
        <h3 class="vc-sales-stats__chart-title">
          <i class="fas fa-credit-card"></i>
          {{ "SALES.STATS.BY_PAYMENT_METHOD" | translate }}
        </h3>
        <div class="vc-sales-stats__chart vc-sales-stats__chart--pie">
          <p-chart
            type="doughnut"
            [data]="paymentMethodChartData"
            [options]="pieChartOptions"
            height="250px"
          ></p-chart>
        </div>
      </div>
    </div>

    <!-- Top Products -->
    <div
      class="vc-sales-stats__section"
      *ngIf="stats.salesByProduct.length > 0"
    >
      <h3 class="vc-sales-stats__section-title">
        <i class="fas fa-star"></i>
        {{ "SALES.STATS.TOP_PRODUCTS" | translate }}
      </h3>
      <div class="vc-sales-stats__products">
        <div
          class="vc-sales-stats__product"
          *ngFor="let product of stats.salesByProduct; let i = index"
        >
          <div class="vc-sales-stats__product-rank">{{ i + 1 }}</div>
          <div class="vc-sales-stats__product-info">
            <span class="vc-sales-stats__product-name">{{ product.name }}</span>
            <span class="vc-sales-stats__product-count"
              >{{ product.count }} {{ "SALES.STATS.UNITS" | translate }}</span
            >
          </div>
          <div class="vc-sales-stats__product-total">
            {{ formatCurrency(product.total) }}
          </div>
        </div>
      </div>
    </div>

    <!-- Payment Method Breakdown -->
    <div
      class="vc-sales-stats__section"
      *ngIf="objectKeys(stats.salesByPaymentMethod).length > 0"
    >
      <h3 class="vc-sales-stats__section-title">
        <i class="fas fa-wallet"></i>
        {{ "SALES.STATS.PAYMENT_BREAKDOWN" | translate }}
      </h3>
      <div class="vc-sales-stats__methods">
        <div
          class="vc-sales-stats__method"
          *ngFor="let method of stats.salesByPaymentMethod | keyvalue"
        >
          <div class="vc-sales-stats__method-name">{{ method.key }}</div>
          <div class="vc-sales-stats__method-stats">
            <span class="vc-sales-stats__method-count"
              >{{ method.value.count }} ventas</span
            >
            <span class="vc-sales-stats__method-total">{{
              formatCurrency(method.value.total)
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div
    class="vc-sales-stats__empty"
    *ngIf="!loading && stats && stats.totalSales === 0"
  >
    <i class="fas fa-chart-pie"></i>
    <h3>{{ "SALES.STATS.NO_DATA" | translate }}</h3>
    <p>{{ "SALES.STATS.NO_DATA_DESCRIPTION" | translate }}</p>
  </div>
</div>
